import React, { useEffect, useState } from 'react';  
import { connect } from 'react-redux';
import { combineDispatchers, combineStates, dialogDispatcher, siteSettingsState } from '../../../store';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import { translate } from '../../../services';
import { closeIcon, closePopup, infoIcon, whiteInfoIcon } from '../../../../style/images';
import { SvgImage } from '../../../components';


const BannerComponent = (props)=>{
const {mobileView} =props;
    const [showWelcome, setShowWelcome] = useState(false)

    const showNotification= props.siteSettings.properties?.showNotification
    
    useEffect(()=>{
      if(mobileView){
        const welcomeMessageMobile = localStorage.getItem("visitedMobile");
        if (!welcomeMessageMobile) {
          setShowWelcome(true);
          localStorage.setItem("visitedMobile", true);
        }
      }
      else{
        const welcomeMessage = localStorage.getItem("visited");
        if (!welcomeMessage) {
          setShowWelcome(true);
          localStorage.setItem("visited", true);
        }
      }
    })

    const closeShowWelcome = ()=>{
      setShowWelcome(false);
    }
    const handletoggleModal = ()=>{
      props.showDialog(<div className="banner-panel">
        <SvgImage source={ whiteInfoIcon } className="message-icon"/>
        <div className="banner-content">
          <div className='header'>
            <div className='title'>{translate("Notifications")}</div>
          </div>
          <div className='body'>
            <ul>
              <li>
                <a
                  href="https://econfigure.xe.abb.com/global/#/"
                  target="_blank"
                >
                  Emax
                </a>{" "}
                {translate("is now avalible in e-Configure")}
              </li>
              <li>{translate("Accessory grouping available")}</li>
              <li>{translate("VD4 NST data available")}</li>
            </ul>
          </div>
        </div>
        <div className="separator"></div>
        <SvgImage source={ closePopup } className="close-icon" onClick={()=>{ props.closeDialog()} }/>
      </div>,
      {className:"banner"}
      )
    }

    const dismissWelcomeMessage = ()=>{
      setShowWelcome(false)
    }
    return(showNotification && showWelcome &&  <div className="china-banner"> 
    <div className="banner-text">
        <div className="notification">
                <span>
                {translate("Banner")}{" "}
                  {/* <a
                    href="https://econfigure.xe.abb.com/global/#/"
                    target="_blank"
                  > */}
                    {/* {translate("here")} */}
                  {/* </a>{" "} */}
                  {/* {translate("for detail information")} */}
                  {/* <span className="ellipses" onClick={handletoggleModal}>...</span> */}
                </span>
              </div>
              <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{closeShowWelcome()}} width="12px" height="12px" padding="0px">
                            <Box component="img" src={closePopup} sx={{height:"12px", width:"12px"}}></Box>
            </MuiIconButton>
        </div>
    </div>)
}

export const Banner = connect(combineStates(siteSettingsState), combineDispatchers(dialogDispatcher))(BannerComponent)